<script>
    import AppLayout from "../components/shared/AppLayout.svelte";
    import AlertManagement from "../components/alert_management/AlertManagement.svelte";
    import MainHeader from "../components/shared/MainHeader.svelte";
    import AlertsHeader from "../components/alert_management/AlertsHeader.svelte";

</script>

<MainHeader/>
<AppLayout mainContent={AlertManagement} subHeader="{AlertsHeader}"/>